import type { MouseEventHandler, VFC } from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  button: {
    color: '#FF0000', // テキストの色を暖かみのある赤に変更
    border: '1px solid #FF0000', // 枠線の色を暖かみのある赤に変更
    fontSize: 16,
    height: 48,
    marginBottom: 16,
    width: 256,
    backgroundColor: '#A52A2A1F', // 背景色をかなり薄くした暖かみのある赤に変更
    '&:hover': {
      backgroundColor: '#A52A2A3F', // ホバー時の背景色を少し濃くした暖かみのある赤に変更
    },
  },
});

type Props = {
  label: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
};

export const LogOutButton: VFC<Props> = (props: any) => {
  const { label, onClick } = props;
  const classes = useStyles();

  return (
    <Button
      className={classes.button}
      variant='outlined'
      onClick={() => onClick()}
    >
      {label}
    </Button>
  );
};
